/*jshint esversion: 9 */
import { mapGetters, mapActions } from 'vuex';
import colors from 'vuetify/lib/util/colors';

export const WorkPackageReworkMixin = {
  props: ['backlog', 'prefix'],
  components: {
  },
  data: () => ({
    is_edit: false,
    loading: false,
    save_btn_loading: false,
    delete_btn_loading: false,
    show_filter: localStorage.getItem('LOGLIST_filter') || false,
    light_mode: {
      delta_foreground_color: '',
      delta_light_mode: '',
    },
  }),
  computed: {
    ...mapGetters('Ultra', [
      'getUObjects',
      'getUObject'
    ]),
    ...mapGetters('View', [
      'isMobile',
      'isShowOwnWps'
    ]),
    ...mapGetters('Project', [
      'isEditMode',
      'getOwnTWorkPackages',
      'getProjectTooltip',
      'hasProjectPermissionForTWP'
    ]),
    ...mapGetters('ProjectStructure', [
      'getElementsTotals',
      'calcAllWorkStepsTotal',
      'calcStepTotal',
    ]),
    histprefix(){
      if (this.location.includes('HistProjectTaktPlan')) {
        return 'hist';
      } else {
        return '';
      }
    },
    workpackage_url() {
      let url;
      if (this.backlog) {
        url = [
          {projects: this.project_id},
          {[`${this.histprefix}wbgroups`]: this.wbgroup_id},
          {[`${this.histprefix}wblines`]: this.wbline_id},
          {[`${this.histprefix}wbworkpackages`]: this.workpackage_id},
        ];
      } else {
        url = [
          {projects: this.project_id},
          {[`${this.histprefix}trains`]: this.train_id},
          {[`${this.histprefix}taktareas`]: this.taktarea_id},
          {[`${this.histprefix}twaggons`]: this.twaggon_id},
          {[`${this.histprefix}tworkpackages`]: this.workpackage_id},
        ];
      }
      if (this.location.includes('HistProjectTaktPlan')) {
        url.splice(1, 0, {histprojects: this.$route.params.histproject_id });
      }
      return url;
    },
    project_id() { return this.$route.params.project_id; },
    train_id() { return this.$route.params.train_id; },
    taktarea_id() { return this.$route.params.taktarea_id; },
    twaggon_id() { return this.$route.params.twaggon_id; },
    // tworkpackage_id() { return this.$route.params.tworkpackage_id; },
    wbgroup_id() { return this.$route.params.wbgroup_id; },
    wbline_id() { return this.$route.params.wbline_id; },
    // wbworkpackage_id() { return this.$route.params.wbworkpackage_id; },
    workpackage_id() {
      if (this.backlog) {
        return this.$route.params.wbworkpackage_id;
      } else {
        return this.$route.params.tworkpackage_id;
      }
    },
    workpackage() {
      if (this.backlog) {
        return this.$store.state.Ultra[`${this.histprefix}wbworkpackages`][this.$route.params.wbworkpackage_id];
      } else if (this.step_card) {
        return Object.assign(JSON.parse(JSON.stringify(this.$store.state.Ultra.tworkpackages[this.$route.params.tworkpackage_id])), {color: 'white', textcolor: 'black'});
      } else {
        return this.$store.state.Ultra[`${this.histprefix}tworkpackages`][this.$route.params.tworkpackage_id];
      }
    },
    content_id() { return this.$route.params.content_id; },
    workpackage_fg_hex() {
      this.color_update_key;
      let textcolor = this.workpackage.textcolor;
      if (this.$store.state.View.font_color_settings.source === 'user'){
        return this.$store.state.View.font_color_settings.color;
      }
      if (textcolor.includes('black')) {
        return '#000'
      } else if (textcolor.includes('white')) {
        return '#FFF'
      } else {
        return colors[textcolor];
      }
    },
    workpackage_bg_hex() {
      if (this.isShowOwnWps && this.getOwnTWorkPackages(this.project_id).length !== 0 && !this.getOwnTWorkPackages(this.project_id).includes(this.workpackage.id)) {
        return '#616161';
      } else {
        let color = this.workpackage.color;
        if (color.includes('black')) {
          return '#000';
        } else if (color.includes('white')) {
          return '#FFF';
        } else {
          let color_parts = color.split(' ');
          if (color_parts.length === 1) {
            color_parts.push('lighten-1');
          }
          let color_part_first = color_parts[0].split("-");
          color_parts[0] = `${color_part_first[0]}${color_part_first.length > 1?color_part_first[1].substring(0,1).toUpperCase():''}${color_part_first.length > 1?color_part_first[1].substring(1):''}`;

          color_parts[1] = color_parts[1].replace("-","");

          if (colors[color_parts[0]]) {
            // vuetify standard colors
            return colors[color_parts[0]][color_parts[1]];
          } else {
            // vuetify theme colors -> old values
            let theme_colors = this.$vuetify.theme.themes[this.$vuetify.theme.isDark?'dark':'light'];
            if (theme_colors[color]) {
              return theme_colors[color];
            } else {
              // default value yellow lighten-1
              return '#ffee58';
            }
          }
        }
      }

    },
    is_create() {return this.content_id === 'create' || this.image_id === 'create' || this.element_id === 'create' || this.$route.name === `${this.location}WorkPackageCamera`;},
  },
  methods: {
    ...mapActions('Ultra', [
      'createUObject',
      'updateUObject',
      'deleteUObject',
      'updateUObjectPosition',
    ]),
    updateWorkpackageValue(key, value) {
      if (this.backlog) {
        this.updateUObject({
          url: this.workpackage_url,
          update: {
            [key]: value
          }
        });
      } else {
        this.requestSnackbarUpdate({
            url: this.workpackage_url,
            update: {
              [key]: value
            },
            selector: "target"
          }).then((payload) => {
            this.updateUObject(payload);
          });
      }
    },
    ///////////// dark mode light mode, performance ?? //////////////////
    // returns a boolean which evaluates if light mode (true) or dark mode (false) should be used
    is_light_mode(foreground_color) {
      let lm = this.light_mode;
      if(lm.delta_light_mode === '' || lm.delta_foreground_color != foreground_color) {
        lm.delta_foreground_color = foreground_color;
        lm.delta_light_mode = this.getHexToHsl(foreground_color).l < 50;
      }
      return lm.delta_light_mode;
    },
    // hsl as object of hex color: call this when you need hsl values of hex color for example to check for luminosity
    // hex_color is color in format of '#FFF', '#FFFFFF' (no transparency), '#FFFF', '#FFFFFFFF' (existing transparency)
    getHexToHsl(hex_color) {
      // existing transparency gets discarded
      if(hex_color.length == 5) { hex_color = hex_color.slice(0, 4); }
      if(hex_color.length == 9) { hex_color = hex_color.slice(0, 7); }

      // checks if hex_color is a valid hexadecimal color value
      var legal_chars = /[0-9A-Fa-f]/g;
      if(hex_color[0] != '#' || !(hex_color.length == 4 || hex_color.length == 7) || !legal_chars.test(hex_color)) {
        return { h: 0, s: 50, l: 50};
      }

      // https://css-tricks.com/converting-color-spaces-in-javascript/
      // Convert hex to RGB first
      let r = 0, g = 0, b = 0;
      if (hex_color.length == 4) {
        r = "0x" + hex_color[1] + hex_color[1];
        g = "0x" + hex_color[2] + hex_color[2];
        b = "0x" + hex_color[3] + hex_color[3];
      } else if (hex_color.length == 7) {
        r = "0x" + hex_color[1] + hex_color[2];
        g = "0x" + hex_color[3] + hex_color[4];
        b = "0x" + hex_color[5] + hex_color[6];
      }

      // Then to HSL
      r /= 255;
      g /= 255;
      b /= 255;
      let cmin = Math.min(r,g,b),
          cmax = Math.max(r,g,b),
          delta = cmax - cmin,
          h = 0,
          s = 0,
          l = 0;

      if (delta == 0)
        h = 0;
      else if (cmax == r)
        h = ((g - b) / delta) % 6;
      else if (cmax == g)
        h = (b - r) / delta + 2;
      else
        h = (r - g) / delta + 4;

      h = Math.round(h * 60);

      if (h < 0)
        h += 360;

      l = (cmax + cmin) / 2;
      s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
      s = +(s * 100).toFixed(1);
      l = +(l * 100).toFixed(1);
      return { h: h, s: s, l: l};
    },
    getMassRelationUnit(mass_relation) {
      let expense_unit = this.$store.state.Ultra.expense_units.find(unit => unit.value === mass_relation);
      if (expense_unit) {
        return expense_unit.unit
      }
      return 'nn';
    },

    // transparent colors: call this when you want 'hex_color' to be 'opacity' percent opaque
    // hex_color is color in format of '#FFF', '#FFFFFF' (no transparency), '#FFFF', '#FFFFFFFF' (existing transparency)
    getTranspHexColor(hex_color, opacity) {
      // existing transparency gets discarded
      if(hex_color.length == 5) { hex_color = hex_color.slice(0, 4); }
      if(hex_color.length == 9) { hex_color = hex_color.slice(0, 7); }

      // checks if hex_color is a valid hexadecimal color value
      var legal_chars = /[0-9A-Fa-f]/g;
      if(hex_color[0] != '#' || !(hex_color.length == 4 || hex_color.length == 7) || !legal_chars.test(hex_color)) {
        return '#888';
      }

      let hex_opacity;
      if(opacity === undefined) { opacity = .5 }
      if(hex_color.length == 4) { // if format is '#FFF' we can only increment by 1/16th
        hex_opacity = parseInt(15 * opacity).toString(16).toUpperCase();
      }
      else { // if format is '#FFFFFF' we can increment by 1/256th
        hex_opacity = parseInt(255 * opacity).toString(16).toUpperCase();
        if(hex_opacity.length != 2) { hex_opacity = '0' + hex_opacity }
      }

      return`${hex_color}${hex_opacity}`;
    },
  }
};
